var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('the-navbar'),_c(_vm.activeView,{tag:"component"}),_c('vue-confirm-dialog'),_c('notifications',{attrs:{"position":"bottom right","group":"foo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }